import React, { useState, useRef } from 'react';
import {  useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import Modal from "react-bootstrap/Modal";
import ReCaptcha from "react-google-recaptcha-enterprise";

import back from "~/assets/images/arrow.svg";
import valegasicon from '~/assets/images/vale-gas.svg';
import { InfoButton, InfoButtonDisabled } from '~/components/layout/Buttons';
import HeaderDesktop from "~/components/layout/Header";
import SideBar from "~/components/layout/Sidebar";
import api from '~/services/api';
import HeaderMobile from '~/components/layout/HeaderOld';
import OpenChatBot from '~/components/layout/Chatbot';

import {
  BackIcon,
  Content,
  DivisionButton,
  DivisionChangeName,
  HeaderContainer,
  HeaderMobileContainer,
  IconLoading,
  InsertName,
  Left,
  PageContainer,
  PageTitle,
  ValeIcon,
  ModalErrorMessage,
  CaptchaArea
} from './styles';

export default function GasVoucherValidation() {
  const captchaSitekey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const captchaRef = useRef(null)

  const history = useHistory();
  const [codeChanged, setCodeChanged] = useState('');
  const [loadingSave, setLoadingSave] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [tokenReCaptcha, setTokenReCaptcha] = useState(null);

  const stores = useSelector((state) => state.economicGroupReducer.stores);

  async function handleCodeValidation() {
    setLoadingSave(true);
    // const tokenInvisible = await captchaRef.current.executeAsync();
    const token = captchaRef.current.getValue();
    setTokenReCaptcha(token)
    if(codeChanged !== '' && token) {
      const header = {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      };
      const parameters = {
        headers: header,
      };
      const url = `/residential/store/v1/voucher/user-me/validate`;
      const storeId = localStorage.getItem("storeId");
      const body = {
        voucherCode: codeChanged,
        storeId: storeId,
        captchaToken: token
      }
      api.post(url, body, parameters)
      .then(async (res) => {
        setCodeChanged('');
        toast.success("Vale validado com sucesso");
      })
      .catch((err) => {
        console.log("err", err.response)
        if (err.response.status < 500) {
          setShowModal(true);
          setErrorMessage(err.response.data.message);
          //toast.error(err.response.data.message);
        } else {
          toast.error("Ocorreu um erro ao tentar validar o vale");
        }
      }).finally(() => {
        setLoadingSave(false);
        setTokenReCaptcha(null);
        captchaRef.current.reset();
      })
    } else {
      toast.error("O código de validação não pode ser vazio");
      setLoadingSave(false);
    }
  }

  const handleRecaptchaChange = (value) => {
    setTokenReCaptcha(value);
  };

  return(
    <PageContainer>
      <SideBar menuSelected={"Minha Conta"}>
        <DivisionChangeName>
          <HeaderContainer>
            <HeaderDesktop
              stores={stores}
            />
          </HeaderContainer>
          <HeaderMobileContainer>
            <HeaderMobile />
          </HeaderMobileContainer>
          <Modal
            show={showModal}
            centered
          >
            <ModalErrorMessage>
              <WarningIcon
                style={{
                  width: '3rem',
                  height: '3rem',
                  margin: '0 0 1rem 0'
                }}
              />
              <span>{errorMessage}</span>
              <InfoButton
                onClick={() => {
                  setCodeChanged('');
                  setShowModal(false)
                }}
                style={{
                  width: '25%',
                  margin: '1rem auto 0 auto'
                }}
              >Ok</InfoButton>
            </ModalErrorMessage>
          </Modal>
          <Content>
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}>
              <Left>
                <ValeIcon src={valegasicon} alt="Ícone do vale gás" />
                <PageTitle>Vale Gás</PageTitle>
              </Left>
              <BackIcon>
                <img
                  src={back}
                  alt="Ícone para voltar"
                  onClick={() => {
                    history.push('/valegas');
                  }}
                />
              </BackIcon>
            </div>
            <InsertName>
              <label>
                <CheckCircleIcon style={{
                  width: '1em',
                  margin: '0 .3rem .3rem .3rem'
                }} />
                Validar Vale gás
              </label>
              <input
                maxlength="99"
                value={codeChanged}
                onChange={(e) => setCodeChanged(e.target.value)}
                placeholder="Código de autorização ou n° do vale"
              />
            </InsertName>
            <CaptchaArea>
              <ReCaptcha
                sitekey={captchaSitekey}
                ref={captchaRef}
                onChange={handleRecaptchaChange}
                style={{
                  width: '100%'
                }}
              />
              {/* <ReCaptcha sitekey={captchaSitekey} ref={captchaRef} size="invisible" /> */}
            </CaptchaArea>
            <DivisionButton>
              {(!tokenReCaptcha || codeChanged === '') && (
                <InfoButtonDisabled >
                {loadingSave ? (
                  <IconLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                ) : "Validar"}
              </InfoButtonDisabled>
              )}
              {tokenReCaptcha && codeChanged !== '' && (
                <InfoButton onClick={() => handleCodeValidation()}>
                  {loadingSave ? (
                    <IconLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                  ) : "Validar"}
                </InfoButton>
              )}
            </DivisionButton>
          </Content>
        </DivisionChangeName>
        <OpenChatBot />
      </SideBar>
    </PageContainer>
  );
}
